export const specailities = [
  "Andrologist & Lap Surgeon",
  "Cardiology",
  "Cardio-Vascular Surgery",
  "Chest Diseases",
  "COVID-19(Coronavirus)",
  "Dentist",
  "Dermatology",
  "Diabetes & Hormone",
  "Dietician",
  "ENT",
  "EYE",
  "Gastroenterology",
  "General Physician",
  "General Surgery",
  "Gynae & Gynaeoncology",
  "Gynaecology & Infertility",
  "Haematology",
  "Medicine",
  "Nephrology (Nephrologist & Medical Specialist)",
  "Neurologist",
  "Neurosurgeon & Spine Surgeon",
  "Nutrition (Overweight, child nutrition & diet therapy)",
  "Onclogy (Cancer)",
  "Orthopaedic",
  "Paedistrician & Paediatric cardiology",
  "Pain Medicine",
  "Pediatrics & Neonate (Child)",
  "Physical Medicine",
  "Physiotherapy",
  "Plastic Surgery",
  "Psychiatrist",
  "Respiratory Medicine",
  "Skin & VD",
  "Urologist",
  "Vascular Surgery",
];

export const designations = [
  "Professor",
  "Associate Professor",
  "Assistant Professor",
  "Senior Consultant",
  "Junior Consultant",
  "Consultant",
  "Medical Officer",
];
